var scope_0 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/179cced02ba0d48ac1a86ebd4b97573e.js').default;
var scope_1 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2982cc71a7ba25932377cf3890b1f6a8.js').default;
var scope_2 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/51b70d9097865bd9a07524bb5e5beeeb.js').default;
var scope_3 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5671b847e78a8e8f62e778bda42f676b.js').default;
var scope_4 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/679b3070cb36c834a2bf485ad2324b44.js').default;
var scope_5 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/72a223e613111bdf7d20cfbdfd66a547.js').default;
var scope_6 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/91d25765d855befd1605b3984a348052.js').default;
var scope_7 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/94a881aea7a111946bf1751bf124a254.js').default;
var scope_8 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/978af53d02d7d0d00136c49e8d49d6d3.js').default;
var scope_9 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/99c470974837e95d8eae235f608ea536.js').default;
var scope_10 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9dd2b609618b59cddfeb641536954ce5.js').default;
var scope_11 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c141b47a9b04a68de1ecef19f5496516.js').default;
var scope_12 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d222369c85dcd9964fb4ec1b4f7652ef.js').default;
var scope_13 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9,
scope_10,
scope_11,
scope_12,
scope_13 )
    